import { render, staticRenderFns } from "./tmsPlatformGpsConfig.vue?vue&type=template&id=3c42ff3b"
import script from "./tmsPlatformGpsConfig.vue?vue&type=script&lang=js"
export * from "./tmsPlatformGpsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports